// Mirrors the styling half of src/server/emailRoutes.js's genHtml(text) exactly (same
// regexes) so Settings > Templates can preview a template's message as it would actually
// render in a sent email. Kept as a separate copy rather than a shared import because the
// backend is plain CommonJS (require) and this is loaded into the Vite/ESM frontend bundle -
// if the real genHtml's styling ever changes, mirror the change here too.
export function styleMessageText(text) {
  let styledText = text.replace(/\*\*\*(.*?)\*\*\*/g, "<b><i>$1</i></b>");
  styledText = styledText.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
  // [^*\n]+ rather than .*? - an unpaired single '*' (e.g. used as a footnote marker) would
  // otherwise happily pair with the next unrelated '*' anywhere later in the text and
  // italicise everything in between.
  styledText = styledText.replace(/\*([^*\n]+)\*/g, "<i>$1</i>");
  styledText = styledText.replace(/\^\^(.*?)\^\^/g, '<em style="font-size: 11px;">$1</em>');
  styledText = styledText.replace(/__(.*?)__/g, "<u>$1</u>");
  return styledText;
}
